<template>
  <div>
    <div v-if="isMobileOrTablet" class="mt-2">
      <div class="pb-5">
        <appHeader></appHeader>
        <transition appear name="fade">
          <div class="container account">
            <div class="row pb-5">
              <div class="col-12">

                <div class="wl-header">
                  <h5 class="wl-title">
                    My wishlist
                    <span class="wl-count">({{ itemsCount | numToLocale }})</span>
                  </h5>
                </div>

                <div v-if="itemsCount === 0" class="wl-empty-state">
                  <div class="wl-empty-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                  </div>
                  <p class="wl-empty-title">Your wishlist is empty</p>
                  <p class="wl-empty-desc">
                    Save items you love and come back to them anytime. Start browsing to add your favorites.
                  </p>
                  <div class="wl-recs-label">Recommended for you</div>
                  <appWhatsNewBarHorizontal></appWhatsNewBarHorizontal>
                </div>

                <div
                  v-for="item in wishlistItems"
                  v-else
                  :key="item.id"
                  class="wl-card"
                >
                <a :href="`/shop/product/1/${item.productId}`" class="wl-img-wrap">
                  <img :alt="item.productName" :src="item.imageUrl" />
                </a>

                  <div class="wl-body">
                    <a :href="`/shop/product/1/${item.productId}`" class="wl-name">
                      {{ item.productName }}
                      <span v-if="item.productVersionSpecValue" class="wl-variant">
                        · {{ item.productVersionSpecValue }}
                      </span>
                    </a>

                    <p v-if="!item.productVersionDeleted" class="wl-price">
                      {{ itemPointsDisplayed(item.pointsPerUnit, item.taxPointsPerUnit) | numToLocale }}
                      <span>Points</span>
                    </p>
                    <div v-if="item.productVersionDeleted" class="wl-unavail">
                      <font-awesome-icon icon="exclamation-circle" />
                      Currently unavailable &nbsp;<strong>· Remove to continue</strong>
                    </div>

                    <div class="wl-actions">
                      <button v-if="!item.productVersionDeleted" class="btn-wl-cart" v-on:click="addToCart(item.productVersionId)">
                        <font-awesome-icon icon="cart-plus" />
                        Move to cart
                      </button>
                      <span v-if="!item.productVersionDeleted" class="wl-divider"></span>
                      <a class="btn-wl-remove" v-on:click="deleteWishlistItem(item.id)">
                        <font-awesome-icon icon="trash" />
                        Remove
                      </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </transition>
      </div>
      <navigationFooter></navigationFooter>
    </div>

    <!-- Desktop -->
    <div v-else class="mt-2">
      <appHeader></appHeader>
      <transition appear name="fade">
        <div class="container account">
          <div class="row">
            <div class="col-12">

              <div class="wl-header">
                <h5 class="wl-title">
                  My wishlist
                  <span class="wl-count">({{ itemsCount | numToLocale }})</span>
                </h5>
              </div>

              <div v-if="itemsCount === 0" class="wl-empty-state">
                <div class="wl-empty-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                </div>
                <p class="wl-empty-title">Your wishlist is empty</p>
                <p class="wl-empty-desc">
                  Save items you love and come back to them anytime. Start browsing to add your favorites.
                </p>
                <div class="wl-recs-label">Recommended for you</div>
                <appWhatsNewBarHorizontal></appWhatsNewBarHorizontal>
              </div>

              <div
                v-for="item in wishlistItems"
                v-else
                :key="item.id"
                class="wl-card"
              >
                <a :href="`/shop/product/1/${item.productId}`" class="wl-img-wrap">
                  <img :alt="item.productName" :src="item.imageUrl" />
                </a>

                <div class="wl-body">
                  <a :href="`/shop/product/1/${item.productId}`" class="wl-name">
                    {{ item.productName }}
                    <span v-if="item.productVersionSpecValue" class="wl-variant">
                      · {{ item.productVersionSpecValue }}
                    </span>
                  </a>

                  <p v-if="!item.productVersionDeleted" class="wl-price">
                    {{ itemPointsDisplayed(item.pointsPerUnit, item.taxPointsPerUnit) | numToLocale }}
                    <span>Points</span>
                  </p>
                  <div v-if="item.productVersionDeleted" class="wl-unavail">
                    <font-awesome-icon icon="exclamation-circle" />
                    Currently unavailable &nbsp;<strong>· Remove to continue</strong>
                  </div>

                  <div class="wl-actions">
                    <button
                      v-if="!item.productVersionDeleted"
                      class="btn-wl-cart"
                      v-on:click="addToCart(item.productVersionId)"
                    >
                      <font-awesome-icon icon="cart-plus" />
                      Move to cart
                    </button>
                    <span v-if="!item.productVersionDeleted" class="wl-divider"></span>
                    <a class="btn-wl-remove" v-on:click="deleteWishlistItem(item.id)">
                      <font-awesome-icon icon="trash" />
                      Remove
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </transition>
      <appFooter></appFooter>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import WhatsNewBarHorizontal from "@/components/WhatsNewBarHorizontal.vue";
import { isMobile, isTablet } from "mobile-device-detect";
import navigationFooter from "../../components/navigationFooter.vue";
import { mapState } from "vuex";

export default {
  components: {
    appHeader: Header,
    appFooter: Footer,
    appWhatsNewBarHorizontal: WhatsNewBarHorizontal,
    navigationFooter: navigationFooter,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      grossUpTaxes: (state) => state.company.grossUpTaxes,

      itemsCount: (state) => state.wishlist.summary.items,
      wishlistItems: (state) => state.wishlist.items,
    }),
    isMobileOrTablet: function() {
      return isMobile || isTablet;
    },
  },
  methods: {
    itemPointsDisplayed: function(pointsPerUnit, taxPointsPerUnit) {
      if (this.grossUpTaxes) {
        return pointsPerUnit + taxPointsPerUnit;
      } else {
        return pointsPerUnit;
      }
    },
    deleteWishlistItem: function(wishlistItemId) {
      this.$store
        .dispatch("wishlist/removeWishlistItem", wishlistItemId)
        .catch(() => {
          this.showError("Failed to remove product from wishlist");
        });
    },
    addToCart: async function (productVersionId) {
      await this.$store
        .dispatch("cart/addCartItem", {
          productVersionId: productVersionId,
          quantity: 1,
          categoryID: 1,
        })
        .then(() => {
            this.$router.push('/cart');   // ← redirect to cart on success
        })
        .catch(() => {
          alert("Failed to add item to cart");
        })
        .finally(() => {
          this.isAddProcessing = false;
        });
    },
    showSuccess: function(message, onClose) {
      this.$bvModal
        .msgBoxOk(message, {
          size: "sm",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then(() => {
          onClose();
        });
    },
    showError: function(message) {
      this.$bvModal.msgBoxOk(message, {
        size: "sm",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        okVariant: "danger",
        centered: true,
      });
    },
  },
  created() {
    this.$store.dispatch("wishlist/fetchWishlist");
    this.$store.dispatch("wishlist/fetchWishlistSummary");
  },
};
</script>

<style lang="scss" scoped>
.container.account {
  min-height: 90vh;
  padding-top: 3em;
}

// Header
.wl-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}
.wl-title {
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0;
}
.wl-count {
  font-size: 0.875rem;
  color: $gray-500;
  font-weight: 400;
  margin-left: 6px;
}

// Card
.wl-card {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: $border-radius;
  padding: 1rem 1.25rem;
  margin-bottom: 0.75rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: $gray-400;
  }
}

// Image
.wl-img-wrap {
  display: block;
  width: 90px;
  min-width: 90px;
  height: 90px;
  border-radius: $border-radius-sm;
  overflow: hidden;
  background: $gray-100;        // light bg so transparent PNGs look clean
  border: 1px solid $gray-200;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;        // ← was "cover", now shows full image
    object-position: center;
    display: block;
    padding: 4px;               // small breathing room around the product
  }
}

// Body
.wl-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.wl-name {
  font-size: 0.95rem;
  font-weight: 500;
  color: $gray-900;
  text-decoration: none;
  line-height: 1.4;

  &:hover {
    color: $primary;
    text-decoration: none;
  }
}

.wl-variant {
  font-size: 0.8rem;
  font-weight: 400;
  color: $gray-500;
}

.wl-price {
  font-size: 0.95rem;
  font-weight: 600;
  color: #3782f3;
  margin: 0;

  span {
    font-size: 0.8rem;
    font-weight: 400;
    color: #3782f3;
    margin-left: 3px;
  }
}

.wl-unavail {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: $danger;
  background: lighten($danger, 42%);
  border-radius: $border-radius-sm;
  padding: 4px 10px;
  width: fit-content;
}

// Actions
.wl-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.btn-wl-cart {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid $gray-300;
  border-radius: $border-radius-sm;
  padding: 5px 14px;
  font-size: 0.8rem;
  font-weight: 500;
  color: $gray-800;
  cursor: pointer;
  transition: background 0.12s ease;

  &:hover {
    background: $gray-100;
  }
}

.wl-divider {
  width: 1px;
  height: 18px;
  background: $gray-300;
  display: inline-block;
  margin: 0 4px;
}

.btn-wl-remove {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  color: #f87a55;
  padding: 5px 10px;
  border-radius: $border-radius-sm;
  cursor: pointer;
  transition: color 0.12s ease, background 0.12s ease;
  text-decoration: none;

  &:hover {
    color: $danger;
    background: lighten($danger, 42%);
    text-decoration: none;
  }
}

// Empty state
.wl-empty-state {
  text-align: center;
  padding: 3rem 1rem 2rem;
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: $border-radius;
  margin-bottom: 1.5rem;
}

.wl-empty-icon {
  color: $gray-400;
  margin-bottom: 1rem;
}

.wl-empty-title {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.4rem;
}

.wl-empty-desc {
  font-size: 0.875rem;
  color: $gray-500;
  max-width: 340px;
  margin: 0 auto 1.5rem;
  line-height: 1.6;
}

.wl-recs-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: $gray-500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.75rem;
}

// Mobile tweaks
@media (max-width: 576px) {
  .wl-card {
    padding: 0.85rem;
    gap: 0.75rem;
  }
  .wl-img-wrap {
    width: 70px;
    min-width: 70px;
    height: 70px;
  }
}
// Points — matches product detail page
.wl-price {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin: 2px 0;
}
.wl-price-num {
  font-size: 1.4rem;
  font-weight: 700;
  color: $primary; // same blue as product page
  line-height: 1;
}
.wl-price-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: $primary;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

// Move to cart — solid blue matching "Add to Cart"
.btn-wl-cart {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: $primary;
  border: none;
  border-radius: $border-radius-sm;
  padding: 8px 18px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: darken($primary, 8%);
  }
}

@media (max-width: 576px) {
  .wl-img-wrap {
    width: 80px;
    min-width: 80px;
    height: 80px;
  }
}
</style>